'use client';
import Lottie from 'lottie-react';
import React from 'react';
import orthLoopDark from '~/public/assets/ORTH_Logo_Loop_Dark.json';
import orthLoopLight from '~/public/assets/ORTH_Logo_Loop_Light.json';
import { useThemeStore } from '../stores/useThemeStore';
import { cn } from '@AydiTeam1/aydi-ui';
import { useMainAppStore } from '../stores/mainAppStore';

export const OrthLottie: React.FC<{ theme: 'Light' | 'Dark' }> = ({ theme }) => {
  const mapper = {
    Dark: orthLoopDark,
    Light: orthLoopLight,
  };
  return (
    <Lottie
      animationData={theme ? mapper[theme] : mapper.Light}
      autoplay
      className={'w-[375px] h-[390px] max-sm:w-[85%]'}
    />
  );
};

const OrthSplash = () => {
  const theme = useThemeStore((s) => s.mode);
  if (!theme) return null;

  return <OrthLottie theme={theme} />;
};

const OrthLoading = () => {
  const theme = useThemeStore((s) => s.mode);
  const appLoading = useMainAppStore((s) => s.appLoading);
  if (!appLoading || !theme) return null;
  return (
    <div
      className={cn(
        'fixed top-0 bottom-0 start-0 end-0 flex items-center justify-center z-[9999]',
        theme == 'Dark' ? 'bg-[#000000b2]' : 'bg-[#FFFFFFB2]'
      )}
    >
      <OrthLottie theme={theme} />
    </div>
  );
};

export { OrthSplash, OrthLoading };
